import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import get from 'lodash/get';
import LegacyTextRenderer from './LegacyTextRenderer';
import ExcerptRenderer from './ExcerptRenderer';
import BaseViewer from '../DaEditorWrapper/Viewer/Base';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import WrapWidth from './WrapWidth';
const TextRenderer = /*#__PURE__*/ React.forwardRef(({ textContent, className, fallbackToExcerpt = true, reactViewer, htmlExcerptLegacy, isPollWithHtmlExcerpt, width, legacyTheme, excerptOnly, viewerKey, disableStylesForLegacy, emptyPlaceHolder = '', fixedParagraph, draftjsThemeOverride, disableLazyLoading, withSafetyCheckModal }, ref)=>{
    if (!textContent) {
        return null;
    }
    const type = get(textContent, 'html.type');
    const markup = get(textContent, 'html.markup');
    if (!markup || excerptOnly) {
        if (!fallbackToExcerpt) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "TextRendererExcerpt"
        }, /*#__PURE__*/ React.createElement(ExcerptRenderer, {
            textContent: textContent,
            className: className,
            emptyPlaceHolder: emptyPlaceHolder,
            legacyTheme: legacyTheme,
            htmlExcerptLegacy: htmlExcerptLegacy,
            isPollWithHtmlExcerpt: isPollWithHtmlExcerpt,
            disableStylesForLegacy: disableStylesForLegacy,
            ref: ref
        }));
    }
    switch(type){
        case 'writer':
            return /*#__PURE__*/ React.createElement(ErrorBoundary, {
                debugComponent: "TextRendererWriter"
            }, /*#__PURE__*/ React.createElement(WrapWidth, {
                width: width,
                ref: ref
            }, /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
                className: className,
                html: markup,
                theme: legacyTheme,
                disableStyles: disableStylesForLegacy,
                withSafetyCheckModal: withSafetyCheckModal
            })));
        case 'draft':
            const Viewer = reactViewer || BaseViewer;
            // do not add theme when not asked for
            const viewerTheme = draftjsThemeOverride ? {
                theme: draftjsThemeOverride
            } : {};
            try {
                return /*#__PURE__*/ React.createElement(ErrorBoundary, {
                    debugComponent: "TextRendererDraft"
                }, /*#__PURE__*/ React.createElement(WrapWidth, {
                    width: width,
                    ref: ref
                }, /*#__PURE__*/ React.createElement("div", {
                    className: className
                }, /*#__PURE__*/ React.createElement(Viewer, _object_spread({
                    key: viewerKey,
                    content: JSON.parse(markup),
                    fixedParagraph: fixedParagraph,
                    disableLazyLoading: disableLazyLoading
                }, viewerTheme)))));
            } catch (e) {
                return null;
            }
        default:
            return null;
    }
});
TextRenderer.displayName = 'TextRenderer';
export default TextRenderer;

//# sourceMappingURL=TextRenderer.js.map